import React from "react";
// import ReactDom from 'react-dom';
import '../style.css' ;
import Navbar from "../components/Navbar";
import Header from "../components/Header";
import 'bootstrap/dist/css/bootstrap.min.css';
import { Link } from "react-router-dom";
// import 'bootstrap/dist/js/bootstrap.bundle.min'; 
import Cardwhy from "../components/cardwhy";
import data from "../components/Whydata";
import Dealdata from "../components/Dealdata";
import Deal from "../components/Deal";
import Reviews from "../components/CustomerReviews";
import CustomerCard from "../components/CustomerCard";
import Footer from "../components/Footer";
import Partner from "../components/Partner";
import Pdata from "../components/Partnerdata";
import ReactPlayer from "react-player";
import { Helmet } from 'react-helmet';
import ScrolltoTop from "../components/ScrolltoTop";
// import WhatsAppButton from "../components/WhatsAppButton";
import useWhatsAppUTMLinkUpdater from "../components/useWhatsAppUTMLinkUpdater";


function Home() {

  useWhatsAppUTMLinkUpdater();
  
  return (
    <>
     <Helmet>
        <title>TIRUN: India’s Cruise Experts | Official Partner of Royal Caribbean</title>
        <meta name="description" content="TIRUN Travel Marketing is India’s leading cruise expert and exclusive representative of Royal Caribbean, Celebrity Cruises, Silversea and Azamara Cruises. Book world-class cruise vacations today!" />
      </Helmet>
    <div className="home-page-container">
    <Navbar/>
    <Header/>


<div>
<div className="Video-container">
    <div>
    <ReactPlayer
      url="https://youtu.be/Gu0agyaJBoE"
      width="600px"
      height="340px"
      controls={false}
      playing={true} 
      id="short-video"
    />
    </div>
    <div className="video-content">
      <h2>TIME FOR
      NEW ADVENTURES</h2>
      <p>TIRUN Travel Marketing along with Royal Caribbean Group, pioneered cruising in India 30 Years ago. <br></br><br></br>

As the exclusive India representatives of Royal Caribbean International, Celebrity Cruises, Silversea and Azamara Cruises, TIRUN offers you unforgettable vacations onboard the most innovative ships, to the most sought after destinations around the world.<br></br><br></br>

We have a cruise for every mood and invite you to come and CHOOSE THE CRUISING LlFE WITH US!</p>
    </div>
   </div>


</div>


    <div className="why-us-section">
        <p>Experience Matters</p>
        <h2>WHY CHOOSE TIRUN</h2>
        <div className="why-us-card">
            <Cardwhy img={data[0].img } heading={data[0].heading} para={data[0].para} />
            <Cardwhy img={data[1].img } heading={data[1].heading} para={data[1].para} />
            <Cardwhy img={data[2].img } heading={data[2].heading} para={data[2].para} />
            <Cardwhy img={data[3].img } heading={data[3].heading} para={data[3].para} />
        </div>
    </div>
  
   <div className="Deal-section">
   <p>Don’t miss</p>
   <h2>TIRUN SPECIAL OFFERS</h2>
   <div className="Deal-card">
   <a href="https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&destinationtype=All&CruiseLine=8&Destinations=16,39,40,41,18&sortColumn=cruiselinePriority&sortOrder=asc" target="_self" rel="noopener noreferrer">  <Deal img={Dealdata[0].img } Dealname={Dealdata[0].Dealname}  /></a>
             <a href="https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&destinationtype=All&CruiseLine=2&Destinations=1&sortColumn=cruiselinePriority&sortOrder=asc" target="_self" rel="noopener noreferrer"> <Deal img={Dealdata[1].img } Dealname={Dealdata[1].Dealname}  /></a>
             <a href="https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&destinationtype=All&CruiseLine=8&Destinations=7,9,10,13,14&sortColumn=cruiselinePriority&sortOrder=asc" target="_self" rel="noopener noreferrer"> <Deal img={Dealdata[2].img } Dealname={Dealdata[2].Dealname}  /></a>
             <a href="https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&destinationtype=All&CruiseLine=8&Destinations=19&sortColumn=cruiselinePriority&sortOrder=asc" target="_self" rel="noopener noreferrer"> <Deal img={Dealdata[3].img } Dealname={Dealdata[3].Dealname}  /></a>
        </div>
   </div>


  {/* <div className="Discover"> */}

   {/* <div className="Places" >
    <p>Places to go</p>
    <h2>CRUISE BY DESTINATIONS</h2>
    <p className="places-para">Discover the world with TIRUN! Between our brands we sail to 900+ destinations across all seven continents and oceans. Pick a destination and explore the cruising life onboard contemporary family to expedition to small boutique ships to relaxed luxury resorts at sea.<br></br><br></br>

With TIRUN’s exclusive offers, you can indulge in the best of cruise vacations while exploring the world’s most exotic locations.</p>
   </div> */}

   {/* <div className="places-carousel">
             <Deal img={Dealdata[1].img } Dealname={Dealdata[1].Dealname}  />
            <Deal img={Dealdata[2].img } Dealname={Dealdata[2].Dealname}  />
            <Deal img={Dealdata[3].img } Dealname={Dealdata[3].Dealname}  /> */}
   {/* <div id="carouselExampleIndicators" class="carousel slide ajslider"> */}
  {/* <div class="carousel-indicators">
    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1" aria-label="Slide 2"></button>
    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2" aria-label="Slide 3"></button>
  </div> */}
{/* 
  <div class="carousel-inner">
    <div class="carousel-item active">
      <img src="" class="d-block w-100" alt="..."/>
    </div>
    <div class="carousel-item">
      <img src=""  class="d-block w-100" alt="..."/>
    </div>
    <div class="carousel-item">
      <img src="" class="d-block w-100" alt="..."/>
    </div>
   
  </div> */}
  {/* <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Previous</span>
  </button>
  <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
    <span class="carousel-control-next-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Next</span>
  </button> */}
{/* </div> */}
   {/* </div> */}
   {/* </div> */}

<div className="Partner-section">
  <h2>Our Partner Cruise Brands</h2>
  <div className="partner-card">
  <Link to="/royalcaribbean" className="sub-link"> <Partner img={Pdata[0].img } partner={Pdata[0].partner} /></Link>
  <Link to="/celebritycruises" className="sub-link"> <Partner img={Pdata[1].img } partner={Pdata[1].partner}  /></Link>
  <Link to="/silversea" className="sub-link"> <Partner img={Pdata[2].img } partner={Pdata[2].partner}  /></Link>
    <a href="https://booking.tirun.com/swift/cruise?siid=1035987&lang=1&destinationtype=All&CruiseLine=1043&sortColumn=price&sortOrder=asc" target="_self" rel="noopener noreferrer"> <Partner img={Pdata[3].img } partner={Pdata[3].partner}  /></a>
  </div>
</div>






   <div className="Customer-review">
    <h2>Customer Reviews</h2>
    <div className="customer-slider">
      <CustomerCard name={Reviews[0].name} date={Reviews[0].date} review={Reviews[0].review}/>
      <CustomerCard name={Reviews[1].name} date={Reviews[1].date} review={Reviews[1].review}/>
      <CustomerCard name={Reviews[2].name} date={Reviews[2].date} review={Reviews[2].review}/>
    </div>
   </div>


  <ScrolltoTop/>

   <Footer/>
   </div>
    </>
    
  );
}

export default Home;
